import type { ComponentSchema } from '../../../../../schema-types'
import { schema as announcementBarSchema } from './announcement-bar.schema'
import { schema as blogSchema } from './blog.schema'
import { schema as brandsSchema } from './brands.schema'
import { schema as ctaSchema } from './cta.schema'
import { schema as flashSaleSchema } from './flash-sale.schema'
import { schema as instagramFeedSchema } from './instagram-feed.schema'
import { schema as lookbookBannerSchema } from './lookbook-banner.schema'
import { schema as newArrivalsSchema } from './new-arrivals.schema'
import { schema as offerBannerSchema } from './offer-banner.schema'
import { schema as productGridSchema } from './product-grid.schema'
import { schema as productSliderSchema } from './product-slider.schema'
import { schema as testimonialsSchema } from './testimonials.schema'
import { schema as bannerCarouselSchema } from './banner-carousel.schema'
import { schema as categoriesSchema } from './categories.schema'
import { schema as categoryBentoSchema } from './category-bento.schema'
import { schema as comboSpotlightSchema } from './combo-spotlight.schema'
import { schema as corporateBandSchema } from './corporate-band.schema'
import { schema as heroSchema } from './hero.schema'
import { schema as productRailSchema } from './product-rail.schema'
import { schema as promisesSchema } from './promises.schema'
import { schema as reviewsSchema } from './reviews.schema'
import { schema as storySchema } from './story.schema'

/** Home section types shared with the Cares designs and Khelaghor schemas for the shared types it renders. */
export const homeSchemas: Record<string, ComponentSchema> = {
  hero: heroSchema,
  'banner-carousel': bannerCarouselSchema,
  categories: categoriesSchema,
  'category-bento': categoryBentoSchema,
  'product-rail': productRailSchema,
  story: storySchema,
  'combo-spotlight': comboSpotlightSchema,
  reviews: reviewsSchema,
  promises: promisesSchema,
  'corporate-band': corporateBandSchema,
  'announcement-bar': announcementBarSchema,
  blog: blogSchema,
  brands: brandsSchema,
  cta: ctaSchema,
  'flash-sale': flashSaleSchema,
  'instagram-feed': instagramFeedSchema,
  'lookbook-banner': lookbookBannerSchema,
  'new-arrivals': newArrivalsSchema,
  'offer-banner': offerBannerSchema,
  'product-grid': productGridSchema,
  'product-slider': productSliderSchema,
  testimonials: testimonialsSchema,
}
